export default {
  "file": "_file_1ltrse",
  "icon": "_icon_1ltrse",
  "info": "_info_1ltrse",
  "filename": "_filename_1ltrse",
  "errors": "_errors_1ltrse"
};